import SectionStack from 'components/common/SectionStack'
import ActiveStylesLink from 'components/links/ActiveStyledLink'
import { H3 } from 'components/typography'
import { FC, ReactNode } from 'react'

const IfopNavigation: FC<{
  links: { to: string; content: string | ReactNode }[]
  title: string
}> = ({ links, title }) => {
  return (
    <SectionStack bg="green.100" rounded="xl" position="sticky" top="calc(117px + 2.5rem)">
      <H3>{title}</H3>
      {links &&
        links.map(({ to, content }) => (
          <ActiveStylesLink
            key={to}
            href={to}
            p="3.5"
            rounded="lg"
            activeLinkStyles={{ fontWeight: '700', bg: 'green.150' }}
          >
            {content}
          </ActiveStylesLink>
        ))}
    </SectionStack>
  )
}

export default IfopNavigation
